import css from 'styled-jsx/css';

const styles = css.global`.sn-text-input input {
  border: none;
  width: 100%;
  padding: 0;
  margin: 0;
  outline: none;

  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #000;
  background: transparent;
}

.sn-text-input input:disabled {
  background: transparent;
}

.sn-text-input {
  border: 1px solid #767676;
  border-radius: 5px;
  height: 40px;
  position: relative;
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.sn-text-input .ic-container {
  display: flex;
  height: 20px;
  width: 20px;
}

.sn-text-input~.input-error-text {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #f14c4c;
  margin-bottom: 8px;
}

.sn-text-input input:disabled {
  color: #767676 !important;
}


@media (min-width: 992px) {
  .sn-text-input {
    height: 54px;
  }

  .sn-text-input input {
    font-size: 18px;
    line-height: 26px;
  }

  .sn-text-input .ic-container {
    display: flex;
    height: 24px;
    width: 24px;
  }

  .sn-text-input~.input-error-text {
    font-size: 18px;
    line-height: 26px;
  }
}

.text-input-label {
  position: relative;
}

.text-input-label label {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  background: white;
  padding: 0 4px;
  transition: 0.2s ease;
  color: #444444;

  font-family: "SantanderText";
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
}

.text-input-label input:focus+label,
.text-input-label input.has-filled-value+label {
  top: 0;
  color: #444444;
  font-size: 14px;
  background: linear-gradient(to bottom, #f5f9fb 50%, transparent 50%);
}`;

export default styles;